import React from "react";
import styled from "styled-components";

interface ConfirmationDialogProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  close?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  show,
  onClose,
  onConfirm,
  onCancel,
  message = "Are you sure?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  close = false,
}) => {
  if (!show) return null;

  return (
    <ConfirmationDialogOverlay>
      <ConfirmationDialogContainer>
        {close && (
          <CloseButton title="Close" onClick={onCancel}>
            &times;
          </CloseButton>
        )}
        <ConfirmationMessage>
          <h2 >{message}</h2>
        </ConfirmationMessage>
        <ConfirmationDialogButtons>
          <button onClick={onClose}>{cancelText}</button>
          <button onClick={onConfirm}>{confirmText}</button>
        </ConfirmationDialogButtons>
      </ConfirmationDialogContainer>
    </ConfirmationDialogOverlay>
  );
};

export default ConfirmationDialog;

// Styled Components
const ConfirmationDialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;


const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #333;
  outline: none;
  transition: color 0.2s;

  &:hover {
    color: #d9534f;
  }
`;

const ConfirmationDialogContainer = styled.div`
  position: relative;
  background: white;
  border-radius: 8px;
  // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  
  padding: 20px;
  width: 300px;
  text-align: center;
  border-color:red;
`;

const ConfirmationDialogButtons = styled.div`
  display: flex;
  justify-content: space-between;
  button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;

    &:first-child {
      background: #ccc;
      color: #333;
    }

    &:last-child {
      background: #d9534f;
      color: white;
    }
  }
`;

const Button = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
`;
const ConfirmationMessage = styled.div`
  color:black;
  background : white;
`;

ConfirmationDialogButtons.defaultProps = {
  children: [
    <Button key="cancel" style={{ background: "#ccc", color: "#333" }}>
      Cancel
    </Button>,
    <Button key="confirm" style={{ background: "#d9534f", color: "white" }}>
      Confirm
    </Button>,
  ],
};

export { ConfirmationDialogOverlay, ConfirmationDialogContainer, CloseButton };
